import CopyTableData from './copyTableData';
import type { CopyTableDataProps, CopyColumnsType, CopyPreviewProps, CheckColumnsProps, } from './interface';

export type { CopyTableDataProps, CopyColumnsType, CopyPreviewProps, CheckColumnsProps, };

export default CopyTableData;
